import { Controller } from '@hotwired/stimulus'

const ACTION_FIELDS = {
  route_to_erp: ['erp_integration_config_id', 'configuration'],
  assign_user: ['rotation_id', 'require_responsibility_confirmation'],
  send_notification: ['whatsapp_chat_id'],
  close_ticket: ['configuration'],
  log_erp_history: ['erp_integration_config_id', 'configuration']
}

export default class extends Controller {
  static targets = [
    'actionTypeInput', 'actionCard', 'actionFields', 'field',
    'advanced', 'advancedBody', 'advancedChevron',
    'eventLabel', 'enabledToggle', 'enabledLabel'
  ]
  static values = { actionType: String }

  connect() {
    this.applyActionType(this.actionTypeValue)
  }

  selectActionType(event) {
    const value = event.currentTarget.dataset.actionType
    this.actionTypeValue = value
    this.actionTypeInputTarget.value = value
    this.actionCardTargets.forEach((c) => {
      c.classList.toggle('is-selected', c.dataset.actionType === value)
    })
    this.applyActionType(value)
  }

  applyActionType(value) {
    const visible = ACTION_FIELDS[value] || []
    this.fieldTargets.forEach((field) => {
      field.classList.toggle('hidden', !visible.includes(field.dataset.actionField))
    })
  }

  toggleEvent(event) {
    const checkbox = event.currentTarget
    const label = checkbox.closest('[data-event]')
    if (!label) return
    label.classList.toggle('is-checked', checkbox.checked)
  }

  toggleAdvanced() {
    this.advancedBodyTarget.classList.toggle('hidden')
    const open = !this.advancedBodyTarget.classList.contains('hidden')
    this.advancedChevronTarget.style.transform = open ? 'rotate(90deg)' : ''
  }

  updateToggle(event) {
    const checkbox = event.currentTarget
    const track = checkbox.parentElement.querySelector('.rc-toggle-track')
    if (track) track.classList.toggle('is-on', checkbox.checked)
  }

  updateEnabledLabel(event) {
    this.updateToggle(event)
    if (this.hasEnabledLabelTarget) {
      this.enabledLabelTarget.textContent = event.currentTarget.checked ? 'Ativa' : 'Inativa'
    }
  }
}
